<div class="offer-content-wrapper">
  <header class="d-flex align-items-baseline justify-content-between flex-wrap">
    <h2 class="offer-title mb-0">Offer Overview</h2>
    @if (offerConfirmationInfo() !== null) {
      <p class="mb-0">
        Offer accepted at {{ offerConfirmationInfo().confirmationDate | date : "shortTime" }}
        on {{ offerConfirmationInfo().confirmationDate | date : "MM/dd/yyyy" }}
      </p>
    }
  </header>

  <div class="mt-5" [innerHTML]="offer.offerDescription | safe : 'html'"></div>

  @for (document of offer.documents; track $index) {
    <app-offer-document [document]="document" [baseurl]="baseurl" />
  }

  <h2 class="offer-form-title mb-0">Acceptance of Offer</h2>
  <div class="border-bottom pb-5 form-wrapper">
    @if (offerConfirmationInfo() !== null) {
      <div class="d-flex text-violet mt-4">
        <img src="assets/icons/vsh/checkmark.svg" alt="" class="mr-1" />
        <p class="mb-0">
          <span class="d-block font-weight-bold">Congratulations!</span>
          <span class="congratulation-message">
            {{ offerConfirmationInfo().acceptedOfferTraitName }} accepted at
            {{ offerConfirmationInfo().confirmationDate | date : "shortTime" }} on
            {{ offerConfirmationInfo().confirmationDate | date : "MM/dd/yyyy" }}.
          </span>
        </p>
      </div>
    } @else {
      <app-offer-form
        [offer]="offer"
        [user]="user"
        (offerFormSubmission)="confirmOffer($event)"
      />
    }
  </div>

  @if (offerConfirmationInfo() !== null) {
    <p class="mt-5 mb-0">{{ offer.successMessage }}</p>

    @for (redirectionLink of offer.redirectionLinks; track $index) {
      <a
        [href]="redirectionLink.url"
        class="text-decoration-none mt-4 d-block redirection-links"
        [ngClass]="{
          'btn-primary': redirectionLink.primary,
          'btn-secondary': !redirectionLink.primary
        }"
      >
        {{ redirectionLink.linkText }}
      </a>
    }
  }

  @if (showToastNotification()) {
    <div
      class="toast-notification d-flex align-items-center justify-content-between mt-4"
    >
      <p class="mb-0">
        <img src="assets/icons/confirmation-positive-green.png" alt="" />
        Offer has been accepted.
      </p>

      <button
        class="border-0 bg-transparent p-0"
        aria-label="close confirmation notification"
        (click)="closeToastNotification()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  }
</div>
